import React, { useState } from "react";
import { Box, Group } from "@mantine/core";
import { Button } from "../Button/Button";
import DentalArchesSvg, { TeethChoice } from "../../components/DentalArchesSvg";
import { Legend } from "./legend/Legend";

export interface DentalSvgWithButtonsProps {
  teethChoices: TeethChoice[];
  disabledTeeth?: number[];
  onClick: (teeth: { name: string; teeth: number[] }[]) => void;
  dataTestId?: string;
  extraButtons?: React.ReactNode;
}

export const DentalSvgWithButtons = ({
  ...props
}: DentalSvgWithButtonsProps) => {
  const [selectedLabel, setSelectedLabel] = useState<string | null>(
    props.teethChoices[0].label
  );
  const [selectedTeeth, setSelectedTeeth] = useState<TeethChoice[]>(
    props.teethChoices
  );
  const [currentColor, setCurrentColor] = useState<string | null>(
    props.teethChoices[0].color
  );
  const handleClick = (tooth: number, label: string) => {
    const selectedTeethItem = selectedTeeth.find(t => t.label === label);

    if (!selectedTeethItem) {
      console.warn(`No teeth choice found for label: ${label}`);
      return; // si pas trouvé on arrete
    }

    if (!Array.isArray(selectedTeethItem.teeth)) {
      selectedTeethItem.teeth = []; // si pas un tableau , on init un tableau vide
    }

    const newSelectedTeethOfLabel = selectedTeethItem.teeth;
    const newSelectedTeeth = [...selectedTeeth];

    if (newSelectedTeethOfLabel.includes(tooth)) {
      // dent déjà selectionné, on la retire

      // on la recherche
      const item = newSelectedTeeth.find(t => t.label === label);

      // si item existe et a un tableau teeth valide
      if (item && Array.isArray(item.teeth)) {
        // on supprime
        item.teeth.splice(newSelectedTeethOfLabel.indexOf(tooth), 1);
      }
    } else {
      // la dent n'est pas dans la catégorie active, on l'ajoute

      // on retire cette dent de toutes les autres catégories,( une dent dans une seule catégorie à la fois)
      newSelectedTeeth
        .filter(t => t.label !== label)
        .forEach(t => {
          // pour chaque catégorie, vérifier si elle contient cette dent
          if (Array.isArray(t.teeth) && t.teeth.includes(tooth)) {
            //si oui la retirer
            t.teeth.splice(t.teeth.indexOf(tooth), 1);
          }
        });

      // ajouter dans la catégorie active
      const item = newSelectedTeeth.find(t => t.label === label);
      if (item) {
        if (!Array.isArray(item.teeth)) {
          item.teeth = [];
        }
        // ajout de la dent
        item.teeth.push(tooth);
      }
    }

    //mise à jour de l'état
    setSelectedTeeth(newSelectedTeeth);

    // on notifie le composant parent des changements
    props.onClick(
      newSelectedTeeth
        .filter(t => Array.isArray(t.teeth) && t.teeth.length > 0)
        .map(t => ({ name: t.name, teeth: t.teeth }))
    );
  };
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 10,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Group style={{ justifyContent: "center" }}>
          <DentalArchesSvg
            {...props}
            disabledTeeth={props.disabledTeeth ?? []}
            newSelectionColor={currentColor}
            teeth={selectedTeeth}
            onClick={tooth => {
              handleClick(tooth, selectedLabel);
            }}
            dataTestId={props.dataTestId}
            width={350}
            height={500}
          />
        </Group>
        <Legend teethChoices={props.teethChoices} />
      </Box>
      <Group
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {props.teethChoices
          .filter(t => !t.hideButton)
          .map(t => (
            <Button
              color={t.color}
              key={`button-${t.key}`}
              variant={
                t.disabled
                  ? "disabled"
                  : t.label === selectedLabel
                    ? undefined
                    : "outline"
              }
              onClick={() => {
                if (t.disabled) return;
                setSelectedLabel(t.label);
                setCurrentColor(t.color);
              }}
              dataTestId={`${props.dataTestId}-${t.key}`}
            >
              {t.label}
            </Button>
          ))}
        {props.extraButtons}
      </Group>
    </Box>
  );
};
